import { render, staticRenderFns } from "./DialogWork.vue?vue&type=template&id=6fcbb198"
import script from "./DialogWork.vue?vue&type=script&lang=ts"
export * from "./DialogWork.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports